$('.customBanners').slick({
 slidesToShow: 2,
 slidesToScroll: 1,
 centerMode: false,
 autoplay: true,
 autoplaySpeed: 5000,
 dots: true,
 arrows: false,
 infinite: true,
 adaptiveHeight: false,

 responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 1, slidesToScroll: 1 }}
  ]
});